import type { AppRouteConfig } from '../../models'
import { FeatureIdEnum } from '../../enums'
import Form from '../../views/beacon-related-tags/related-tags-form.view.vue'
import List from '../../views/beacon-related-tags/related-tags-list.view.vue'
import { ROUTER_CONSTS } from '../router.consts'
import { ENABLED_FILTER_CONFIG } from '../routes.filters'
import { ROUTES_PATHS } from '../routes.paths'

const NAMES = ROUTER_CONSTS.routes[FeatureIdEnum.RELATED_TAGS]

const PATHS = Object.assign(ROUTES_PATHS, {
  root: 'relatedTags',
})

const featureId = FeatureIdEnum.RELATED_TAGS

export const BEACON_RELATED_TAGS_ROUTES: Array<AppRouteConfig> = [
  {
    name: NAMES.list,
    path: PATHS.root,
    component: List,
    meta: {
      featureId,
      filters: () => ({
        regularFiltersEnabled: true,
        extra: { [ENABLED_FILTER_CONFIG.id]: ENABLED_FILTER_CONFIG },
      }),
      style: {
        removeContentPadding: true,
      },
    },
  },
  {
    name: NAMES.create,
    path: `${PATHS.root}/${PATHS.actions.create}`,
    component: Form,
    meta: {
      featureId,
      titleI18nKey: 'createRelatedTags',
      parentRouteName: NAMES.list,
    },
  },
  {
    name: NAMES.update,
    path: `${PATHS.root}/${PATHS.actions.update}`,
    component: Form,
    meta: {
      featureId,
      titleI18nKey: 'updateRelatedTags',
      parentRouteName: NAMES.list,
    },
  },
]
